module.exports = __webpack_public_path__ + "static/media/calendar.ca857db8.svg";